import { AxiosInstance } from "axios";


interface PostcodeAutoCompleteEndpoints{
    postcodeAutoComplete:string,
    [others: string]: any
}

interface PostcodeAutoCompleteConfig{
    axios: AxiosInstance,
    endpoints: PostcodeAutoCompleteEndpoints,
    [others: string]: any
}


export default function(config:PostcodeAutoCompleteConfig){

    const initialState = {
        axios: config.axios,
        endpoint: config.endpoints.postcodeAutoComplete,
    }


    return function(state = initialState, action){

        switch(action.type){
            default: return state
        }

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/postcode-auto-complete/postcode-auto-complete-reducer.ts